import { ReactElement, ReactNodeArray } from 'react';

/* eslint-disable-next-line */
type SidebarItemProps = {
  children: ReactElement | ReactNodeArray;
};

export function SidebarItem(props: SidebarItemProps) {
  const { children } = props;

  return <div className="flex px-4 lg:px-0 space-x-2">{children}</div>;
}

export default SidebarItem;
